<template>
    <DefaultLayout :title="__('admin::general.create_model', {'model': modelNameSingular.toLowerCase() })">
       
        <template #title>
            <InertiaLink :href="indexRoute">{{ modelNamePlural }}</InertiaLink>
            <ChevronRightIcon class="w-6 h-6 inline align-text-top text-gray-300" />
            {{ __('admin::general.create') }} 
        </template>

        <template #default>

            <Panel>
            
                <form @submit.prevent="submit">

                    <slot></slot>

                    <Button :loading="form.processing">
                        {{ __('admin::general.create_model', {'model': modelNameSingular.toLowerCase() }) }}
                    </Button>

                </form>

            </Panel>

        </template>
        
    </DefaultLayout>
</template>

<script>
    import { ChevronRightIcon } from '@heroicons/vue/outline'

    export default {
        components: {
            ChevronRightIcon,
        },
        props: {
            indexRoute: String,
            storeRoute: String,
            modelNameSingular: String,
            modelNamePlural: String,
            form: Object,
        },
        methods: {
            submit() {
                this.form.post(this.storeRoute);
            }
        },
    }
</script>